//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            loading: true,
            transactions: [],
            account: null,
            headers: ['Date', 'Description', 'Type', { title: 'Amount', filter: 'toCurrency' }],
            fields: ['date', 'name', 'type', 'amount']
        };
    },
    created: function created() {
        Event.$on('show-bank-transactions', this.showBankTransactions);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('show-bank-transactions');
    },

    methods: {
        showBankTransactions: function showBankTransactions(account) {
            var $el = this;
            Event.$emit('show-full-modal');
            axios.post('/prototype/accounting/bank-accounts/transactions', { account: account.account_id, token: account.access_token }).then(function (response) {
                $el.transactions = response.data.transactions;
                $el.account = response.data.account;
                $el.loading = false;
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/banking/BankTransactions.vue
// module id = nQM2
// module chunks = 0 1